//Hooks
import { get } from 'svelte/store';
//Formating
import { format } from 'svelte-i18n';
//Helpers
import { getStatusIconByRole, isXT1Module } from 'src/helpers/xt1_helpers/template_helpers';
import { getVirtualComponentsActions } from '../../webhooks/core/webhook_virtual_helpers';
// Stores
import { devices_settings } from 'src/stores/device-runtime/status';
//Types
import type { LabelProps } from '@Shelly/shelly-design-system';
import type { ActionJob } from 'src/types/requests/schedules/schedules_g2';
import type { Device } from 'src/types/Device';

export const buildVirtualLabels = (deviceID: Device['id'], job: ActionJob, labelList: LabelProps[]) => {
	const label = stringifyVirtualLabel(job, deviceID, true);
	if (label) labelList.push(label);
	return labelList;
};

export const stringifyVirtualLabel = (
	job: ActionJob,
	deviceID: string,
	scheduleLabel = false,
): LabelProps => {
	if (job?.method) {
		const method = job.method.toLowerCase();
		const deviceSettings = devices_settings.getByRealId(deviceID);
		const component = `${method.split('.')[0]}:${job.params?.id}`;
		const localAction = getVirtualComponentsActions([component], deviceSettings)?.[0];
		if (!localAction) {
			return { value: method };
		}
		let icon = localAction.icon;
		let value = job?.params?.[localAction.type == 'button' ? 'event' : 'value'];
		if (value != null && localAction.enums) {
			const _enum = localAction.enums.find((i) => RegExp(`^${value}$`, 'i').test(i.value));
			if (_enum) {
				icon = _enum.icon;
				value = _enum.title;
			}
		}
		if (isXT1Module(deviceSettings?.device?.type)) {
			const roleIcon = getStatusIconByRole(localAction.role);
			if (roleIcon && scheduleLabel) {
				return {
					value: localAction.unit ? `${value} ${localAction.unit}` : value,
					icon: roleIcon,
				};
			}
			if (/^(true|false)$/.test(value)) {
				const $format = get(format);
				value = /^(true)$/.test(value)
					? $format('on_action', { default: 'on' })
					: $format('off_action', { default: 'off' });
			}
			return {
				value:
					value != localAction.title
						? `${localAction.title}: ${value} ${localAction.unit}`
						: localAction.title,
				icon: icon || null,
			};
		}
		return {
			value: `${localAction.title}: ${value} ${localAction.unit}`,
			icon: icon || null,
		};
	}
	return null;
};
